/*eslint-disable*/
import axios from 'axios';
// import { BASE_URL } from '../constants/api_urls';
import StorageService from '../services/StorageService';
import SessionService from '../services/SessionService';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = StorageService.getJWTToken() || SessionService.getJWTToken();
  config.headers['Authorization'] = token ? 'Bearer ' + token : '';
  return config;
});

// ...existing code...
// заменено: вместо глобальных response/sendRefresh используется refreshTokenPromise
let refreshTokenPromise = null;

api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (err) => {
    const originalRequest = err?.config;

    console.log("🚀 ~ status:", err.response.status)
    console.log("🚀 ~ message:", err.response.data?.message)
    if (!err?.response) {
      return Promise.reject(err);
    }

    const status = err.response.status;
    const message = err.response.data?.message;

    if (
      status === 401 &&
      message?.toLowerCase() === 'token is expired' &&
      originalRequest &&
      !originalRequest._isRetry
    ) {
      originalRequest._isRetry = true;

      try {
        if (!refreshTokenPromise) {
          refreshTokenPromise = axios.get(
            `${process.env.REACT_APP_BASE_URL}/v3/auth/refresh_token`,
            { withCredentials: true },
          );
        }

        const tokenResponse = await refreshTokenPromise;
        refreshTokenPromise = null;

        const newToken = tokenResponse?.data?.token;
        if (!newToken) {
          throw new Error('No token in refresh response');
        }

        if (StorageService.getJWTToken()) {
          StorageService.setItem('acc', newToken);
        } else {
          SessionService.setItem('acc', newToken);
        }

        originalRequest.headers = originalRequest.headers || {};
        originalRequest.headers.Authorization = `Bearer ${newToken}`;

        return api.request(originalRequest);
      } catch (refreshError) {
        refreshTokenPromise = null;

        StorageService.removeJWTToken('acc');
        StorageService.removeItem('rfr');
        SessionService.removeJWTToken('acc');
        SessionService.removeItem('rfr');

        if (
          refreshError?.response?.status === 401 &&
          refreshError?.response?.data?.message === 'cookie token is empty'
        ) {
          window.location.href = '/login';
        }

        return Promise.reject(refreshError);
      }
    } else if (status === 403 || message === 'cookie token is empty') {
      StorageService.removeJWTToken('acc');
      StorageService.removeItem('rfr');
      SessionService.removeJWTToken('acc');
      SessionService.removeItem('rfr');
      return Promise.reject(err);
    }

    return Promise.reject(err);
  },
);

export default api;
export { axios };
